import type { AmplitudeEnrichmentPlugin } from './consentModePlugin'

/** SDK-internal identify events: user-property operations, no event properties. */
const IDENTIFY_EVENT_TYPES = new Set(['$identify', '$groupidentify'])

/**
 * Stamps `browser_time_zone` (IANA, e.g. `Europe/London`) on every event the
 * page sends (TASK-1172). It stands in for country: the cookieless mode
 * sends Amplitude no IP, so 81% of web users had no country, and the one
 * question the audience research could not answer — is this visitor already
 * in London or planning a trip — is what the time zone tells. Read in the
 * browser; no address leaves the page. A browser whose `Intl` throws sends
 * the event without it.
 */
export function browserTimeZonePlugin(
  readTimeZone: () => string = () => Intl.DateTimeFormat().resolvedOptions().timeZone,
): AmplitudeEnrichmentPlugin {
  return {
    name: 'metro-browser-time-zone',
    type: 'enrichment',
    execute: async (event) => {
      if (IDENTIFY_EVENT_TYPES.has(event.event_type)) return event
      let timeZone: string | undefined
      try {
        timeZone = readTimeZone()
      } catch {
        return event
      }
      if (!timeZone) return event
      event.event_properties = { ...event.event_properties, browser_time_zone: timeZone }
      return event
    },
  }
}
